import React from "react";

/**
 * Full-viewport loading state shown while a public site's data is being
 * fetched. Presentational only — no data fetching here. `theme` selects the
 * accent color so it matches the page that renders it.
 */
export default function SiteLoadingState({ theme = "personal", label = "Loading site…" }) {
    const accent = theme === "business" ? "#1f6b45" : "#2563eb";

    return (
        <div
            role="status"
            aria-live="polite"
            style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: 16,
                minHeight: "100vh",
                background: "#f8f9fa",
                fontFamily: "Inter, system-ui, sans-serif",
            }}
        >
            <span
                aria-hidden="true"
                style={{
                    width: 44,
                    height: 44,
                    borderRadius: "50%",
                    border: "4px solid #e6e3da",
                    borderTopColor: accent,
                    animation: "site-loading-spin 0.9s linear infinite",
                }}
            />
            <span style={{ color: "#6b7280", fontSize: 14, fontWeight: 600 }}>{label}</span>
            <style>{`@keyframes site-loading-spin { to { transform: rotate(360deg); } }`}</style>
        </div>
    );
}
